import moment from "moment";

export function formatDate(dateString) {
    const momentObject = moment(dateString)
    return dateString && momentObject.isValid() ? momentObject.format("DD MMM, YYYY") : "-"
}